import axios from 'axios';
import '../CSS/style.css';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { CHAT, IPAddress } from '../../../commons/api';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import React, { useEffect, useState, useRef } from 'react';
import { Button, Input, Upload, message, Modal } from 'antd';
import { SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { checkFileAlreadyExistsOrNot, getFileData } from '../Utils/ApICalls';

const FileUpload = ({ translationCache }) => {
  const [files, setFiles] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [viewModal, setViewModal] = useState(false);
  const [fileExist, setFileExist] = useState(false);
  
  const searchInputRef = useRef(null);

  useEffect(() => {
    getAttachmentList();
  }, []);

  const getAttachmentList = async () => {
    const filesData = await getFileData();
    setFiles(filesData);
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={translation('Search')}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleCancel = () => {
    setViewModal(false);
  };

  const handleOk = async () => {
    setViewModal(false);
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    
    let url = `${CHAT.Upload}?SiteId=${siteId}`;
    
    let formData = new FormData();
    formData.append('file', newImages[0]);
    formData.append('OverWrite', fileExist);

    try {
      await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      message.success('File uploaded Successfully');
      getAttachmentList();
    } catch (error) {
      console.error(error);
      message.error('Failed to upload file');
    }
  };

  const columns = [
    {
      title: translation('File Name'),
      dataIndex: 'FileName',
      key: 'FileName',
      ...getColumnSearchProps('FileName'),
      render: (text, record) => (
        <a
          href={`${IPAddress.LOCAL}/api/${record.FilePath}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {text}
        </a>
      )
    },
    {
      title: translation('Attachment Type'),
      dataIndex: 'AttachmentType',
      key: 'AttachmentType'
    },
    {
      title: translation('Updated By'),
      dataIndex: 'UpdatedBy',
      key: 'UpdatedBy'
    },
    {
      title: translation('Updated Date'),
      dataIndex: 'UpdatedDate',
      key: 'UpdatedDate'
    }
  ];

  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  
  return (
    <div style={{ margin: '20px' }}>
      <Upload
        name="file"
        showUploadList={false}
        action={`${CHAT.Upload}?SiteId=${siteId}`}
        multiple={false}
        headers={{
          Authorization: `Bearer ${token}`
        }}
        beforeUpload={async (uploadedFile) => {
          let payload = { FileName: uploadedFile.name };
          let fileExistResponse = await checkFileAlreadyExistsOrNot(payload);

          if (fileExistResponse.FileStatus !== 'false') {
            setNewImages([uploadedFile]);
            setFileExist(fileExistResponse.FileStatus);
            setViewModal(true);
            return false;
          } else {
            return true;
          }
        }}
        onChange={(info) => {
          if (info.file.status === 'done') {
            message.success('File uploaded Successfully');
            getAttachmentList();
          } else if (info.file.status === 'error') {
            message.error('Failed to upload file');
          }
        }}
      >
        <Button type='primary' icon={<UploadOutlined />}>Upload a file</Button>
      </Upload>
      
      <Modal open={viewModal} footer={null}>
        <div>
          <p>Do you want to overwrite the existing file?</p>
          <div style={{ marginTop: '5%' }}>
            <Button onClick={handleOk}>Yes</Button>
            <Button style={{ marginLeft: '2%' }} onClick={handleCancel}>No</Button>
          </div>
        </div>
      </Modal>

      <StyledTable size="small"
        style={{ marginTop: '20px' }}
        columns={columns}
        dataSource={files}
        scroll={{ x: 1000, y: 1000 }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(FileUpload);
